/* Cryova storefront behaviour. Prices come from js/catalog.js (mirrors server/catalog.json). */
(function () {
  const C = window.CRYOVA_CATALOG || { items: { 'CRYOVA-1': { price: 449 } } };
  const price = C.items['CRYOVA-1'].price;
  document.querySelectorAll('[data-price]').forEach(el => { el.textContent = price.toLocaleString('en-AE'); });

  /* nav border on scroll */
  const nav = document.querySelector('.nav');
  const onScroll = () => nav && nav.classList.toggle('scrolled', window.scrollY > 8);
  onScroll(); addEventListener('scroll', onScroll, { passive: true });

  /* reveal on scroll */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => {
    es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  document.querySelectorAll('.reveal').forEach(el => io ? io.observe(el) : el.classList.add('in'));
  /* safety: nothing may stay hidden if the observer never fires (print, odd browsers, full-page capture) */
  setTimeout(() => document.querySelectorAll('.reveal:not(.in)').forEach(el => el.classList.add('in')), 2500);

  /* hero LCD: a Gulf afternoon cabin cooling down to the set-point */
  const num = document.getElementById('lcdNum'), state = document.getElementById('lcdState');
  if (num) {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { num.textContent = '4'; state.textContent = 'holding'; }
    else {
      let v = 44; const target = 4; const start = performance.now(); const dur = 3200;
      const ease = t => 1 - Math.pow(1 - t, 3);
      const step = (now) => {
        const t = Math.min(1, (now - start) / dur);
        v = Math.round(44 - (44 - target) * ease(t));
        num.textContent = String(v);
        if (t < 1) requestAnimationFrame(step); else state.textContent = 'holding';
      };
      setTimeout(() => requestAnimationFrame(step), 500);
    }
  }

  /* interactive panel demo */
  const scr = document.getElementById('screen');
  if (scr) {
    const temp = document.getElementById('demoTemp'), mode = document.getElementById('demoMode'),
      hold = document.getElementById('demoHold'), status = document.getElementById('demoStatus'),
      bP = document.getElementById('btnPower'), bA = document.getElementById('btnAuto'),
      bU = document.getElementById('btnUp'), bD = document.getElementById('btnDown');
    let on = true, auto = false, t = 4, timer;
    const render = () => {
      scr.classList.toggle('off', !on);
      status.textContent = on ? 'on' : 'off';
      bP.classList.toggle('active', on); bP.setAttribute('aria-pressed', on);
      bA.classList.toggle('active', on && auto); bA.setAttribute('aria-pressed', on && auto);
      temp.textContent = on ? String(t) : '--';
      mode.textContent = on ? (auto ? 'Auto' : 'Set') : 'Standby';
      hold.textContent = on ? 'Holding' : '';
    };
    const bump = (d) => {
      if (!on) return; auto = false; t = Math.max(0, Math.min(20, t + d));
      hold.textContent = 'Cooling'; render(); hold.textContent = 'Cooling';
      clearTimeout(timer); timer = setTimeout(() => { hold.textContent = 'Holding'; }, 900);
    };
    bP.addEventListener('click', () => { on = !on; if (!on) auto = false; render(); });
    bA.addEventListener('click', () => { if (!on) return; auto = !auto; render(); });
    bU.addEventListener('click', () => bump(+1));
    bD.addEventListener('click', () => bump(-1));
    render();
  }

  /* quantity → checkout link */
  const out = document.getElementById('qtyOut'), buy = document.getElementById('buyBtn');
  if (out && buy) {
    let q = 1;
    const set = (n) => { q = Math.max(1, Math.min(10, n)); out.textContent = q; buy.href = buy.href.replace(/:\d+$/, ':' + q); };
    document.getElementById('qtyMinus').addEventListener('click', () => set(q - 1));
    document.getElementById('qtyPlus').addEventListener('click', () => set(q + 1));
  }
})();
